/**
 * Core domain types shared by the server, the web client and the
 * desktop/mobile shells.
 */
/** How a roll refers to a saved place among its scenes. */
export const PLACE_SCENE_PREFIX = 'place:';
/**
 * The version of the terms and privacy notice a signup agrees to. Bumped when
 * either text changes in a way people must agree to again.
 */
export const TERMS_VERSION = '2026-10-01';
//# sourceMappingURL=types.js.map